import React from 'react';
import {Outlet} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {usePresentationSocket} from '../../utils/hooks/usePresentationSocket';
import TransitionWrapper from '../components/pageTransitions/PageTransitionWrapper';
import Button from '../../incase-domain/components/button/Button';

import NobulaLogo from '../../../assets/icons/NobulaLogo.svg';
import Background1 from '../../../assets/images/auth_bg_1.png';
import Background2 from '../../../assets/images/auth_bg_2.png';
import Background3 from '../../../assets/images/auth_bg_3.png';
import LanguageHeaderItem from '../components/common/header/desktopHeader/LanguageHeaderItem';
import {useRandomRotation} from '../../hooks/useRandomRotation';

function AuthLayout(): JSX.Element {
    usePresentationSocket();

    const {t} = useTranslation();

    const images = [Background1, Background2, Background3];

    const messages = [
        {
            title: 'landingPage.section1.title',
            description: 'landingPage.section1.description',
        },
        {
            title: 'landingPage.section2.title',
            description: 'landingPage.section2.description',
        },
        {
            title: 'landingPage.section3.title',
            description: 'landingPage.section3.description',
        },
        {title: 'landingPage.section4.title', description: 'landingPage.section4.description'},
        {title: 'landingPage.section5.title', description: 'landingPage.section5.description'},
    ] as const;

    const randomRotationImage = useRandomRotation(images, 7000, true);
    const randomRotationMessage = useRandomRotation([...messages], 7000, true);

    return (
        <div>
            <main>
                <div className="l-auth">
                    <div className="l-auth__header">
                        <Button square variant="ghost">
                            <img src={NobulaLogo} alt="Nobula Logo" />
                        </Button>
                        <div className="l-auth__header_title">Nobula Case Creator</div>
                        <div style={{flex: '1'}} />
                        <Button
                            variant="ghost"
                            size="xl"
                            onClick={() => window.open('https://nobula.eu/en/what-is-nobula-case-creator/', '_blank')}
                        >
                            {t('landingPage.learnMore')}
                        </Button>
                        <LanguageHeaderItem theme="light" buttonSize="xl" />
                    </div>
                    <div className="l-auth__body">
                        <div className="l-auth__body_content">
                            <div className="l-auth__body_background u-mb-1">
                                <img
                                    className="l-auth__body_background_image"
                                    src={randomRotationImage.currentItem}
                                    alt="login-background"
                                />
                            </div>
                            <div className="l-auth__body_title">{t(randomRotationMessage.currentItem.title)}</div>
                            <div className="l-auth__body_description">{t(randomRotationMessage.currentItem.description)}</div>
                        </div>
                        <div className="l-auth__body_modal">
                            <TransitionWrapper>
                                <Outlet />
                            </TransitionWrapper>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default AuthLayout;
